import { useRef, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { enterpriseEnrollmentVerificationErrorSelector } from '@hero/redux-data/backoffice/enterpriseEnrollmentVerification/selectors';
import { useNotifications } from '../../context/notification';
const useEnterpriseEnrollmentVerifyFailAlert = () => {
    const { error, originalMessage } = useSelector(enterpriseEnrollmentVerificationErrorSelector, shallowEqual);
    const { addNotification, removeNotification } = useNotifications();
    const id = useRef();
    useEffect(() => {
        id.current && removeNotification(id.current);
        if (error) {
            id.current = addNotification({
                type: 'fail',
                message: originalMessage?.replace(/[_-]/g, ' ') || 'Error verifying enrollment.'
            });
        }
        else {
            id.current = undefined;
        }
    }, [addNotification, removeNotification, error, originalMessage]);
};
export default useEnterpriseEnrollmentVerifyFailAlert;
